import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent, JsonDisplayComponent, ModalBaseComponent, ToasterService } from 'shared';
import { Component, inject, input, output } from '@angular/core';

@Component({
  selector: 'app-credential-json-modal',
  imports: [TranslateModule, ModalBaseComponent, ButtonComponent, JsonDisplayComponent],
  templateUrl: './credential-json-modal.component.html',
  styleUrl: './credential-json-modal.component.scss',
})
export class CredentialJsonModalComponent {
  private toasterService = inject(ToasterService);

  isOpen = input(false);
  credential = input<any>(null);

  close = output<void>();

  onClose() {
    this.close.emit();
  }

  onCopy() {
    const jsonData = this.credential();
    if (!jsonData) {
      this.toasterService.error({ message: 'No credential available to copy' });
      return;
    }

    const jsonText = JSON.stringify(jsonData, null, 2);
    navigator.clipboard
      .writeText(jsonText)
      .then(() => {
        this.toasterService.info({ message: 'Credential copied to clipboard' });
      })
      .catch((error) => {
        console.error('Failed to copy to clipboard:', error);
        this.toasterService.error({ message: 'Failed to copy to clipboard' });
      });
  }

  onDownload() {
    const jsonData = this.credential();
    if (!jsonData) {
      this.toasterService.error({ message: 'No credential available to download' });
      return;
    }

    try {
      const jsonText = JSON.stringify(jsonData, null, 2);
      const blob = new Blob([jsonText], { type: 'application/json' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      const timestamp = new Date().toISOString().split('T')[0];
      const credType = jsonData?.type ? `-${String(jsonData.type).split(',')[0]}` : '';
      link.download = `credential${credType}-${timestamp}.json`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      this.toasterService.success({ message: 'Credential downloaded successfully' });
    } catch (error) {
      console.error('Failed to download credential:', error);
      this.toasterService.error({ message: 'Failed to download credential' });
    }
  }
}
